import { KnownSortOrder } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useNotesWithRelatedResources } from '../../../users/details/hooks/user-notes-card.hook';
import { useInfiniteQueryCourierNotesList } from '../../couriers.queries';

/** Newest first, each linked to the delivery or order it was left on, as on the user details page. */
export function useCourierNotes(courierID: string, projectID: string) {
  return useNotesWithRelatedResources(useInfiniteQueryCourierNotesList(courierID, KnownSortOrder.Desc), projectID);
}
